var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataObservabilityUnclicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_997_12432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.5V14.5H31.5V3.5H27.5ZM30.5 13.5H28.5V4.5H30.5V13.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.558C22.18 8.272 21.8465 8.004 21.5 7.7555V7.5H21.1235C19.175 6.211 16.8715 5.5 14.5 5.5H14V18H26.5V17.5C26.5 16.484 26.3655 15.479 26.113 14.5H26.5V5.5H22.5V8.558ZM25.489 17H15V6.511C16.415 6.576 17.7935 6.9195 19.0645 7.5H17.5V14.5H21.5V9.0335C21.85 9.3225 22.186 9.629 22.5 9.962V14.5H25.078C25.309 15.3155 25.4505 16.1525 25.489 17ZM20.5 8.5V13.5H18.5V8.5H20.5ZM23.5 6.5H25.5V13.5H23.5V6.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64651 15.6484L4.39648 19.8984L5.10358 20.6055L9.35361 16.3555L8.64651 15.6484Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16C6.5 15.173 5.827 14.5 5 14.5C4.173 14.5 3.5 15.173 3.5 16C3.5 16.827 4.173 17.5 5 17.5C5.827 17.5 6.5 16.827 6.5 16ZM4.5 16C4.5 15.724 4.724 15.5 5 15.5C5.276 15.5 5.5 15.724 5.5 16C5.5 16.276 5.276 16.5 5 16.5C4.724 16.5 4.5 16.276 4.5 16Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5C8.173 18.5 7.5 19.173 7.5 20C7.5 20.827 8.173 21.5 9 21.5C9.827 21.5 10.5 20.827 10.5 20C10.5 19.173 9.827 18.5 9 18.5ZM9 20.5C8.724 20.5 8.5 20.276 8.5 20C8.5 19.724 8.724 19.5 9 19.5C9.276 19.5 9.5 19.724 9.5 20C9.5 20.276 9.276 20.5 9 20.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4285 26.2215C23.7795 24.231 24.5 21.9195 24.5 19.5V19H13V7.5H12.5C12.006 7.5 11.5035 7.5435 11 7.607V0.5H0.5V7.5H6.793L7.7695 8.4765C3.3925 10.356 0.5 14.689 0.5 19.5C0.5 26.1165 5.8835 31.5 12.5 31.5C15.4015 31.5 18.1655 30.451 20.3495 28.5565L21.8965 30.1035C22.2005 30.4075 22.6005 30.56 23 30.56C23.3995 30.56 23.7995 30.4075 24.1035 30.1035C24.712 29.495 24.712 28.505 24.1035 27.8965L22.4285 26.2215ZM1.5 6.5V1.5H10V9.293L7.207 6.5H1.5ZM12.5 30.5C6.4345 30.5 1.5 25.5655 1.5 19.5C1.5 14.9545 4.318 10.8765 8.5385 9.2455L11 11.707V8.61C11.3345 8.564 11.669 8.527 12 8.5115V20H23.489C23.4015 21.9725 22.789 23.854 21.71 25.503L20.9125 24.7055C20.9675 24.479 21 24.2435 21 24C21 22.3455 19.6545 21 18 21C16.3455 21 15 22.3455 15 24C15 25.6545 16.3455 27 18 27C18.2435 27 18.479 26.9675 18.7055 26.9125L19.6405 27.8475C17.6475 29.5555 15.136 30.5 12.5 30.5ZM18 26C16.897 26 16 25.103 16 24C16 22.897 16.897 22 18 22C19.103 22 20 22.897 20 24C20 25.103 19.103 26 18 26ZM23.3965 29.3965C23.1775 29.6155 22.8225 29.6155 22.6035 29.3965L19.6865 26.4795C19.998 26.267 20.267 25.998 20.4795 25.6865L23.3965 28.6035C23.615 28.8225 23.615 29.1775 23.3965 29.3965Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2.5H2.5V3.5H9V2.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5H2.5V5.5H9V4.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.5H17.5V24.5H18.5V23.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 23.5H13V24.5H14V23.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5H11V24.5H12V23.5Z",
    fill: "#39ACE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23.5H9V24.5H10V23.5Z",
    fill: "#39ACE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_12432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataObservabilityUnclicked);
export default __webpack_public_path__ + "static/media/Data Observability Unclicked.1fc1cfed0bd6cc4388f9bcaaaff07443.svg";
export { ForwardRef as ReactComponent };